/*global localStorage  */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let Constants = require("../../../../../../utils/Constants");
let SearchForm = require("./SearchForm");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let ComingSoonModal = require("./ComingSoonModal");
// let DeprecatedModal = require("./DeprecatedModal");
let MacContactsModal = require("./MacContactsModal");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");

let ContactToGrab = dd.createClass({
  __onClick: esUtils.wrapPreventDefault(function () {
    this.props.onSelected(this.props.contact.id);
  }),
  render() {
    let { contact } = this.props;

    return dd.div(
      { className: "ContactToGrab row", style: { marginTop: "0.5rem" } },
      dd.div(
        { className: "col-sm-1" },
        dd.a(
          {
            style: { paddingTop: "0", paddingLeft: "0", marginLeft: "0" },
            href: "#",
            className: "btn btn-link btn-sm ",
            onClick: this.__onClick,
          },
          "GRAB"
        )
      ),
      dd.div({ className: "col-sm-11" }, contact.name)
    );
  },
});

let ContactList = dd.createClass({
  render() {
    let { contacts, onSelected } = this.props;

    return dd.div(
      {
        className: "panel panel-default ContactList",
        style: { marginTop: 30 },
      },
      dd.div(
        { className: "panel-body" },
        _.map(contacts, function (contact, i) {
          return ContactToGrab({
            key: i,
            contact: contact,
            onSelected: onSelected,
          });
        }),
        _.size(contacts) === 0
          ? dd.div({ className: "text-center" }, "-- no results --")
          : null
      )
    );
  },
});

module.exports = dd.createClass({
  mixins: [RadioServiceMixin],
  getInitialState() {
    let defaultGrabservice = _.get(this, "props.service");
    if (_.isEmpty(defaultGrabservice)) {
      defaultGrabservice = localStorage.getItem("default_grab_service");
    }
    defaultGrabservice = _.isEmpty(defaultGrabservice)
      ? "EP"
      : defaultGrabservice;
    return { has_searched_yet: false, service: defaultGrabservice };
  },
  RadioService_setup() {
    return {
      ContactGrabber_search: {
        key() {
          return 1;
        },
      },
      ContactGrabber_grab: {
        key() {
          return 1;
        },
        on: {
          succeeded(data, key) {
            this.props.onClose(data, key);
          },
        },
      },
    };
  },
  __onServiceChange: function (e) {
    this.setState({ service: e.target.value, has_searched_yet: false });
  },
  __onSubmit(data) {
    let { event } = this.props;
    let service = this.state.service;
    localStorage.setItem("default_grab_service", service);
    radio("ContactGrabber_search").broadcast({
      grabservice: service,
      searchtext: data.search,
      sids: event.sids,
    });
    this.setState({ has_searched_yet: true });
  },
  __onSelected(contact_id) {
    let { event } = this.props;
    let service = this.state.service;
    radio("ContactGrabber_grab").broadcast({
      grabservice: service,
      contactid: contact_id,
      sids: event.sids,
    });
  },
  render() {
    let { onClose } = this.props;
    let service = this.state.service;
    let ajax_grab = this.state.ContactGrabber_grab;
    let ajax_search = this.state.ContactGrabber_search;

    if (_.includes(Constants.GRAB_SERVICES_not_yet_supported, service)) {
      return ComingSoonModal({ service: service, onClose: onClose });
    }
    if (service === "MAC_CONTACTS") {
      return MacContactsModal({ service, onClose });
    }
    // if(service === "GOOGLEAPI"){
    // 	return DeprecatedModal({service: service, onClose: onClose});
    // }

    return Modal(
      {
        title:
          "Grab a " +
          Constants.GRAB_SERVICES[service] +
          (/contact/i.test(Constants.GRAB_SERVICES[service]) ? "" : " contact"),
        buttons: [],
        onClose: onClose,
      },
      LoadingWrap(
        {
          is_loading: ajax_search.waiting || ajax_grab.waiting,
          text: ajax_grab.waiting
            ? "Copying Contact to Event..."
            : "Searching...",
        },
        ErrorAlert({ message: ajax_grab.error }),
        ErrorAlert({ message: ajax_search.error }),
        dd.div(
          { className: "form-inline" },
          dd.div(
            { className: "form-group" },
            dd.label({ style: { marginRight: 10 } }, "Grab from CRM"),
            dd.select(
              {
                className: "form-control",
                value: service,
                onChange: this.__onServiceChange,
              },
              _.map(Constants.GRAB_SERVICES, function (label, key) {
                return dd.option({ key: key, value: key }, label);
              })
            )
          )
        ),
        SearchForm({ onSubmit: this.__onSubmit }),
        this.state.has_searched_yet
          ? ContactList({
              contacts: ajax_search.data,
              onSelected: this.__onSelected,
            })
          : null
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/ContactGrabber/SearchAContactService.js